export const MESSAGE_TYPE = {
  MESSAGE: 1,
  VIDEO: 2,
  IMAGE: 3,
  AUDIO: 4
} as const;

export const role = {
  BUYER: 1,
  SELLER: 2
};

export const STATUS = {
  BUYER_PENDING: 0,
  BUYER_ACCEPTED: 1,
  BUYER_REJECTED: 2,
  BUYER_INITIATED_FOR_SELLER_PENDING: 3,
  BUYER_INITIATED_FOR_SELLER_REJECTED: 4,
  SELLER_PENDING: 5,
  SELLER_ACCEPTED: 6,
  SELLER_REJECTED: 7
} as const;

export const promotions = {
  PERCENTAGE: 1,
  SPECIAL_DEAL: 2,
  EARLY_ACCESS: 3,
};
